import React, { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { Box, Flex, Icon } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

export type SelectableContainerProps = {
  isSelected?: boolean;
} & ComponentProps<typeof Box>;

const StyledContainer = styled(Box)`
  ${({ isSelected, ...rest }: { isSelected?: boolean }) =>
    isSelected &&
    `
    border-color: transparent;
    outline: 2px solid ${themeGet('components.selectableContainer.color')(
      rest,
    )};
  `}
`;

const IconContainer = styled(Flex)`
  background: ${themeGet('components.selectableContainer.color')};
`;

const TickIcon = styled(Icon)`
  height: ${themeGet('components.selectableContainer.iconSize')};
  width: ${themeGet('components.selectableContainer.iconSize')};
`;

const SelectableContainer = ({
  isSelected,
  children,
  ...rest
}: SelectableContainerProps) => {
  return (
    <StyledContainer isSelected={isSelected} position="relative" {...rest}>
      {isSelected && (
        <IconContainer
          top="-12px"
          right="-12px"
          position="absolute"
          alignItems="center"
          justifyContent="center"
          borderRadius="50%"
          height="32px"
          width="32px"
        >
          <TickIcon data-testid="TICK_ICON" color="white" name="tick" />
        </IconContainer>
      )}
      {children}
    </StyledContainer>
  );
};

export default SelectableContainer;
